module.exports = __webpack_public_path__ + "img/pull_down.4861dd6c.png";